import React, { useEffect, useRef, useState } from "react";

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  makeStyles,
} from "@material-ui/core";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  noteRow: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    border: "1px solid #f0d467",
    borderRadius: 6,
    background: "#fff8d8",
  },
  noteDate: {
    marginBottom: theme.spacing(0.75),
    color: theme.palette.text.secondary,
  },
  noteBody: {
    whiteSpace: "pre-wrap",
    overflowWrap: "break-word",
  },
  emptyText: {
    color: theme.palette.text.secondary,
  },
}));

const TicketNotesModal = ({ modalOpen, onClose, ticket }) => {
  const classes = useStyles();
  const isMounted = useRef(true);
  const [loading, setLoading] = useState(false);
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    const fetchNotes = async () => {
      if (!modalOpen || !ticket?.id) return;

      setLoading(true);
      try {
        const { data } = await api.get(`/tickets/${ticket.id}/notes`);

        if (isMounted.current) {
          setNotes(data.notes || []);
        }
      } catch (err) {
        toastError(err);
      } finally {
        if (isMounted.current) {
          setLoading(false);
        }
      }
    };

    fetchNotes();
  }, [modalOpen, ticket]);

  return (
    <Dialog open={modalOpen} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>{i18n.t("ticketNotesModal.title")}</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <CircularProgress size={24} />
        ) : notes.length ? (
          notes.map(note => (
            <Paper className={classes.noteRow} elevation={0} key={note.id}>
              <Typography variant="caption" className={classes.noteDate}>
                {new Date(note.createdAt).toLocaleString()}
              </Typography>
              <Typography variant="body2" className={classes.noteBody}>
                {note.body}
              </Typography>
            </Paper>
          ))
        ) : (
          <Typography variant="body2" className={classes.emptyText}>
            {i18n.t("ticketNotesModal.empty")}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          {i18n.t("ticketNotesModal.buttons.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketNotesModal;

